import React from 'react';

export interface ArrobaIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const ArrobaIcon: React.FC<ArrobaIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g filter="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18.75 10.75v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94m-2.08-7.94a4 4 0 1 1-8 0 4 4 0 0 1 8 0"/></g><defs><filter id="a" width="32" height="32" x="-1.25" y="-1.251" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"/><feBlend in2="BackgroundImageFix" mode="overlay" result="effect1_dropShadow_23_63385"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation=".5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="effect1_dropShadow_23_63385" mode="multiply" result="effect2_dropShadow_23_63385"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_23_63385" result="shape"/></filter></defs>
    </svg>
  );
};

export default ArrobaIcon;
